<div id="main">
  <header class="position-fixed">
    <div class="logo d-flex align-items-center">
      <img src="./assets/images/logo-antenas.png" alt="TVA Antenas" />
      <button id="togglebutton" class="icon__hamburger">&#9776;</button>
    </div>
    <div class="nav d-flex">
      <div class="nav__titulo">
        <h1>{{ moduleName }}</h1>
      </div>
      <div class="nav__menu ml-auto">
        <!-- <div class="nav__menu--item">
          <div class="buscador">
            <div class="input-group">
              <input
                type="search"
                name="search"
                class="form-control"
                placeholder="Búsqueda"
              />
              <div class="input-group-append">
                <button class="btn btn-search" type="button">
                  <img src="./assets/images/icon-search.png" alt="" />
                </button>
              </div>
            </div>
          </div>
        </div> -->

        <!-- <div class="nav__menu--item">
          <div class="notificaciones">
            <a href="#" id="btn-notificaciones">
              <img src="./assets/images/Icon-notificaciones.svg" alt="" />
            </a>
            <div id="notificaciones">
              <div class="font-weight-bold text-dark border-bottom pl-3">
                <p>Notificaciones</p>
              </div>
              <div class="pt-2 pb-2 border-bottom d-flex">
                <div class="foto">
                  <img
                    class="rounded-circle"
                    src="./assets/images/avatar-default.jpg"
                  />
                </div>
                <div class="datos">
                  <p class="font-weight-bold text-dark pl-3">
                    Juan Pérez
                    <span class="font-weight-light text-secondary"
                      >ha aprobado</span
                    >
                    Plan de trabajo
                  </p>
                  <span class="font-weight-light text-secondary pl-3"
                    >5 min</span
                  >
                </div>
              </div>
              <div class="pt-2 pb-2 border-bottom d-flex">
                <div class="foto">
                  <img
                    class="rounded-circle"
                    src="./assets/images/avatar-default.jpg"
                  />
                </div>
                <div class="datos">
                  <p class="font-weight-bold text-dark pl-3">
                    Minerva Hernández Álvarez
                    <span class="font-weight-light text-secondary"
                      >ha cerrado</span
                    >
                    Auditoría Micronegocio
                  </p>
                  <span class="font-weight-light text-secondary pl-3"
                    >5 min</span
                  >
                </div>
              </div>
              <div class="pt-2 pb-2 border-bottom">
                <div class="datos text-center">
                  <a href="#">Ver más notificaciones</a>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="nav__menu--item">
          <div class="notificaciones">
            <img
              onerror="this.src='./assets/images/avatar-default.jpg';"
              id="userInfo"
              style="border-radius: 100%; cursor: pointer"
              src="https://portal.socio.gs/foto/back_office/empleados/{{
                userSesion?.IdEmpleado
              }}.jpg"
              alt=""
              width="27"
              height="27"
              (click)="userInfo()"
            />
            <div id="dropdown-menu">
              <div class="datos pt-2 pb-2">
                <p class="font-weight-bold text-dark">
                  {{ userSesion?.Nombre }}
                </p>
                <span class="font-weight-light text-secondary">{{
                  userSesion?.Roles[0].Descripcion
                }}</span>
                <span class="font-weight-light text-secondary">{{
                  userSesion?.IdEmpleado
                }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="nav__menu--item">
          <div class="salir">
            <img
              title="Cerrar sesión"
              style="cursor: pointer"
              src="./assets/images/icon-salir.svg"
              alt=""
              (click)="cierreSesion()"
            />
          </div>
        </div>
      </div>
    </div>
  </header>
  <div class="wrapper">
    <div class="sidenav sticky-top">
      <app-menu [menus]="menus"></app-menu>
      <div class="sidenav__logo">
        <img src="assets/images/logo-GS.svg" width="150" height="150" alt="logo-gs" />
        <span class="caption text-center">Todos los derechos reservados</span>
        <span class="caption text-center">Aviso de privacidad</span>
      </div>
    </div>
    <section class="home" style="overflow: auto">
      <div class="container-fluid planeacion">
        <router-outlet></router-outlet>
      </div>
    </section>
  </div>
</div>

<div id="div-loader" class="div-loader" style="display: none">
  <div class="loader-cal" id="loader">
    <div class="item item-1"></div>
    <div class="item item-2"></div>
    <div class="item item-3"></div>
    <div class="item item-4"></div>
  </div>
</div>
